import { useEffect, useState } from "react";
import { Button1 } from "../../../../Components/Buttons";
import { useNavigate } from "react-router-dom";
import { FaLinkedinIn, FaRegHandshake } from "react-icons/fa";
import { FiPhone, FiChevronRight } from "react-icons/fi";
import { GiTakeMyMoney } from "react-icons/gi";
import { GoUnlock } from "react-icons/go";
import { IoIosPeople } from "react-icons/io";
import { IoLocationOutline } from "react-icons/io5";
import { PiCrown, PiSquaresFourLight } from "react-icons/pi";
import { VscMail } from "react-icons/vsc";
import { CreatorSocialCard2 } from "../../../../Components/Brand/Cards/Cards";
import { Contentcard } from "../Discover/DashBoard";
import { useBrand } from "../../../../Providers/Brand";
import { useStaticData } from "../../../../Providers/Data";
import { Modal1, Modal2 } from "../../../../Components/Brand/modals/Modals";
import { useAuth } from "../../../../Providers/Auth";
import { useGeneralSettings } from "../../../../Providers/General";
import { toast } from "react-toastify";
import CircleLoader from "../../../../Components/Brand/Loader/Loader";
import { useCookies } from "react-cookie";

export const UnlockCreatorSearch = () => {
  const authState = useAuth();
  const brandState = useBrand();
  const staticDataState = useStaticData();
  const generalState = useGeneralSettings();

  const navigate = useNavigate();
  const [slug, setSlug] = useState("");
  const [influencer, setinfluencer] = useState({
    influencerData: {},
    collabData: [],
    AudienceCategory: [],
    MonetizedData: [],
    AudienceData: [],
    ContentCategory: [],
    is_unlocked: false,
  });
  const [cookies, , removeCookie] = useCookies();

  //SlectedInfluenceData
  const [selectedInfluencerCoins, setSelectedInfluencerCoins] = useState(0);
  const [selectedInfluencerName, setSelectedInfluencerName] = useState("");
  const [selectedInfluencerprofile, setSelectedInfluencerProfile] =
    useState("");
  const [selectedInfluencerID, setSelectedInfluencerID] = useState(null);

  const [openModal, SetOpenModal] = useState(false);
  const [successModal, OpenSuccessModal] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [wrongLinkError, setWrongLinkError] = useState(false);
  const [NoUserError, setNoUserError] = useState(false);

  //master data
  const [masterContentCategory, setMasterContentCategory] = useState([]);
  const [masterContentFormat, setMasterContentFormat] = useState([]);
  const [masterAudienceTypes, setMasterAudienceTypes] = useState([]);
  const [masterAudiencePlatfroms, setMasterAudiencePlatfroms] = useState([]);
  const [masterCollabGoals, setMasterCollabGoals] = useState([]);
  const [masterMonetizationPlatform, setMasterMonetizationPlatform] = useState(
    []
  );
  const [masterMonetizationServices, setMasterMonetizationServices] = useState(
    []
  );
  const [ChipsRequiredToUnlock, setChipsRequiredToUnlock] = useState(0);
  useEffect(() => {
    staticDataState?.getNewDataFromType("Content Type").then((e) => {
      setMasterContentCategory(e);
    });
    staticDataState?.getNewDataFromType("Content Format").then((e) => {
      setMasterContentFormat(e);
    });
    staticDataState
      ?.getNewDataFromType("lkd_super_master_audienceTypes")
      .then((e) => {
        setMasterAudienceTypes(e);
      });
    staticDataState?.getNewDataFromType("Audience Platform").then((e) => {
      setMasterAudiencePlatfroms(e);
    });
    staticDataState?.getNewDataFromType("Goal / KPI").then((e) => {
      setMasterCollabGoals(e);
    });
    staticDataState?.getNewDataFromType("Platform Name").then((e) => {
      setMasterMonetizationPlatform(e);
    });
    staticDataState?.getNewDataFromType("Services list").then((e) => {
      setMasterMonetizationServices(e);
    });
  }, []);

  useEffect(() => {
    const getInlfuencerByslug = async () => {
      try {
        setLoading(true);
        setinfluencer({
          influencerData: {},
          collabData: [],
          AudienceCategory: [],
          MonetizedData: [],
          AudienceData: [],
          ContentCategory: [],
          is_unlocked: false,
        });
        const Collabregex = /https:\/\/collab\.anchors\.in\//;
        if (!Collabregex.test(slug)) {
          setLoading(false);
          setNoUserError(false);
          return setWrongLinkError(true);
        } else {
          setWrongLinkError(false);
        }

        const result = await brandState?.getInfluencerPersonalInfoBySlug(
          slug?.slice(26)
        );
        if (result?.success) {
          if (result?.resolvedInfluencers?.length === 0) {
            setNoUserError(true);
          } else {
            setNoUserError(false);
          }
          setinfluencer(result?.resolvedInfluencers[0]);
          setChipsRequiredToUnlock(result?.ChipsRequiredToUnlock);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.log("failed");
      }
    };
    getInlfuencerByslug();
  }, [slug]);

  useEffect(() => {
    setSlug(`https://collab.anchors.in/${cookies.unlockCreatorSearch || ""}`);
    removeCookie("unlockCreatorSearch", { path: "/" });
  }, []);

  const handleChange = (e) => {
    setSlug(e.target.value);
  };

  const convertToReadableFormat = (number) => {
    if (Math.abs(number) >= 1000000000) {
      return (number / 1000000000).toFixed(1) + "B";
    } else if (Math.abs(number) >= 1000000) {
      return (number / 1000000).toFixed(1) + "M";
    } else if (Math.abs(number) >= 1000) {
      return (number / 1000).toFixed(1) + "K";
    } else {
      return number.toString();
    }
  };

  const handleUnlockButtonClick = (coins, name, profile, id) => {
    setSelectedInfluencerCoins(coins);
    setSelectedInfluencerName(name);
    setSelectedInfluencerProfile(profile);
    setSelectedInfluencerID(id);
    SetOpenModal(true);
  };

  const handleBuyClick = async () => {
    SetOpenModal(false);
    generalState?.setLoading(true);
    const result = await brandState?.getInfluencerWithCredits(
      selectedInfluencerID,
      true
    );
    if (result?.success) {
      generalState.setLoading(false);
      const result2 = await brandState?.getInfluencerPersonalInfo(
        selectedInfluencerID
      );
      if (result2?.success) {
        setSelectedInfluencerName(result2?.data?.name);
        setSelectedInfluencerProfile(result2?.data?.profile);
        OpenSuccessModal(true);
        authState?.setReFetchBrandData((prev) => !prev);
      } else {
        generalState.setLoading(false);
        toast.error(result2?.error, { autoClose: 1500 });
      }
    } else {
      generalState.setLoading(false);
      toast.error(result?.error, { autoClose: 1500 });
    }
  };

  return (
    <div className="w-full h-full font-inter">
      <div className="flex flex-col w-full h-full overflow-y-auto px-[40px] py-[20px] align-left gap-[20px]">
        <p className=" text-[18px] font-[600] text-[#424242] ">
          Get creator details
        </p>
        <div className="flex gap-[20px] w-full items-center">
          <input
            className="flex grow rounded-[4px]  bg-[transparent] border-[1px] border-[#BDBDBD] text-[14px] font-[400] text-inter text-[#757575] items-center px-[20px] py-[10px]"
            type="text"
            placeholder="Paste another Influencer link here..."
            value={slug}
            onChange={handleChange}
          />
          <Button1
            text={"Get Details"}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
            icon={undefined}
            rightIcon={undefined}
            background={undefined}
            textColor={undefined}
            borderColor={undefined}
          />
        </div>
        <p className=" text-[20px] font-medium text-[#424242] mt-[10px] ">
          Result for:{" "}
          <span
            onClick={() => (slug ? window.open(`${slug}`, "_blank") : "")}
            className="text-[#1D4ED8] cursor-pointer font-normal "
          >
            {slug || "https://collab.anchors.in/"}
          </span>
        </p>
        {Loading && <CircleLoader />}
        {wrongLinkError && (
          <div className="w-full h-full flex justify-center items-center text-[40px] text-[#757575]">
            Invalid Link
          </div>
        )}
        {NoUserError && (
          <div className="w-full h-full flex justify-center items-center text-center text-[24px] text-[#757575]">
            Woopsie-doodle! We couldn't find this creator in our artistic realm
          </div>
        )}
        <div className="w-full flex rounded-[4px] bg-[#fafafa] mt-[20px] mb-[40px]">
          {openModal && (
            <Modal1
              credits={authState?.loggedBrand?.credits}
              coins={selectedInfluencerCoins}
              onClose={() => {
                return SetOpenModal(false);
              }}
              onBuy={() => handleBuyClick()}
              OnClick={() => navigate("/Brand/DashBoard/PurchaseCredits")}
            />
          )}
          {successModal && (
            <Modal2
              onClick={() =>
                navigate(
                  `/Brand/DashBoard/UnlockedInfluencer/Details/?InfluencerID=${selectedInfluencerID}`
                )
              }
              onClose={() => {
                return OpenSuccessModal(false);
              }}
              name={selectedInfluencerName}
              profile={selectedInfluencerprofile}
            />
          )}
          {(influencer?.collabData?.[0]?.data?.length > 0 ||
            influencer?.MonetizedData?.[0]?.data?.length > 0 ||
            influencer?.ContentCategory?.[0]?.length > 0 ||
            influencer?.AudienceData?.[0]?.data?.length > 0 ||
            influencer?.AudienceCategory?.[0]?.length > 0) && (
            <div className="creatorCardLeft">
              <div className="flex flex-col justify-center items-center gap-[12px]">
                <img
                  src={
                    influencer?.influencerData?.profile ||
                    "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/user.png"
                  }
                  onError={(e: any) => {
                    e.target.onerror = null; // Remove the event handler to prevent infinite loops
                    e.target.src =
                      "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/user.png";
                  }}
                  alt=""
                />
                {influencer?.is_featured && (
                  <div className="featuredcontaner">
                    <PiCrown size={16} /> FEATURED
                  </div>
                )}
              </div>
              <h1>{influencer?.influencerData?.name}</h1>
              <div className="creatorinfowrapper">
                <h2>
                  <p
                    className={`${
                      !influencer?.is_unlocked ? "blur-[1px]" : ""
                    }`}
                  >
                    <VscMail size={16} />
                  </p>
                  <div
                    style={{
                      filter: !influencer?.is_unlocked ? "blur(3px)" : "",
                    }}
                  >
                    {" "}
                    {influencer?.influencerData?.email}
                  </div>
                </h2>
                <h2>
                  <p
                    className={`${
                      !influencer?.is_unlocked ? "blur-[1px]" : ""
                    }`}
                  >
                    <FiPhone size={16} />
                  </p>
                  <div
                    style={{
                      filter: !influencer?.is_unlocked ? "blur(3px)" : "",
                    }}
                  >
                    {influencer?.influencerData?.mobile}
                  </div>
                </h2>
                <h2>
                  <p
                    className={`${
                      !influencer?.is_unlocked ? "blur-[1px]" : ""
                    }`}
                  >
                    <IoLocationOutline size={16} />
                  </p>
                  <div
                    style={{
                      filter: !influencer?.is_unlocked ? "blur(3px)" : "",
                    }}
                  >
                    India
                  </div>
                </h2>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <button
                  onClick={() => {
                    if (
                      !/^https?:\/\//i.test(
                        influencer?.influencerData?.LinkedInLink
                      )
                    ) {
                      const profileLink =
                        "https://" + influencer?.influencerData?.LinkedInLink;
                      return window.open(profileLink, "_blank");
                    }

                    window.open(
                      influencer?.influencerData?.LinkedInLink,
                      "_blank"
                    );
                  }}
                  className="LinkedinButton"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FaLinkedinIn size={16} color="#0076B2" />
                    {influencer?.influencerData?.LinkedInFollowers
                      ? `${convertToReadableFormat(
                          parseInt(
                            influencer?.influencerData?.LinkedInFollowers
                          )
                        )}
                      Followers`
                      : "Not Available"}
                  </div>

                  <div style={{ display: "flex", gap: "4px" }}>
                    <FiChevronRight />
                  </div>
                </button>
                {influencer?.is_unlocked ? (
                  <button
                    onClick={() =>
                      navigate(
                        `/Brand/DashBoard/UnlockedInfluencer/Details/?InfluencerID=${influencer?.influencerData?._id}`
                      )
                    }
                    style={{ background: "#10B981" }}
                    className="unlockButton"
                  >
                    <GoUnlock /> {"Profile Unlocked"}
                  </button>
                ) : (
                  <button
                    onClick={() =>
                      handleUnlockButtonClick(
                        ChipsRequiredToUnlock || 0,
                        influencer?.influencerData?.name,
                        influencer?.influencerData?.profile,
                        influencer?.influencerData?._id
                      )
                    }
                    className="unlockButton"
                  >
                    <GoUnlock />{" "}
                    {`Unlock with ${ChipsRequiredToUnlock || 0} Credits`}
                  </button>
                )}
              </div>
            </div>
          )}
          {(influencer?.collabData?.[0]?.data?.length > 0 ||
            influencer?.MonetizedData?.[0]?.data?.length > 0 ||
            influencer?.ContentCategory?.[0]?.length > 0 ||
            influencer?.AudienceData?.[0]?.data?.length > 0 ||
            influencer?.AudienceCategory?.[0]?.length > 0) && (
            <div className="creatorCardRight">
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  width: "100%",
                  gap: "20px",
                }}
              >
                {influencer?.collabData?.[0]?.data?.length > 0 && (
                  <div className="w-[48.5%] flex">
                    <Contentcard
                      icon={<FaRegHandshake color="#424242" size={18} />}
                      heading={"Collab Experience"}
                      number={influencer?.collabData?.[0]?.data?.length}
                      type={influencer?.collabData?.[0]?.data}
                      Objkey="companyName"
                      LinkObjKey="postLink"
                      locked={!influencer?.is_unlocked}
                      bg={"#FAECFF"}
                      padding={"8px 12px"}
                      limit={3}
                      borderRadius={"4px"}
                    />
                  </div>
                )}
                {influencer?.MonetizedData?.[0]?.data?.filter(
                  (item) =>
                    item?.platformName &&
                    masterMonetizationPlatform?.find(
                      (platform) => platform?._id === item?.platformName
                    )?.monetizationPlatformName !== "None"
                )?.length > 0 && (
                  <div className="w-[48.5%] flex">
                    <Contentcard
                      icon={<GiTakeMyMoney color="#424242" size={18} />}
                      heading={"Monetization Avenues"}
                      number={
                        influencer?.MonetizedData?.[0]?.data?.filter(
                          (item) =>
                            item?.platformName &&
                            masterMonetizationPlatform?.find(
                              (platform) => platform?._id === item?.platformName
                            )?.monetizationPlatformName !== "None"
                        )?.length
                      }
                      type={influencer?.MonetizedData?.[0]?.data?.filter(
                        (item) =>
                          item?.platformName &&
                          masterMonetizationPlatform?.find(
                            (platform) => platform?._id === item?.platformName
                          )?.monetizationPlatformName !== "None"
                      )}
                      Objkey="platformName"
                      LinkObjKey="profileLink"
                      locked={!influencer?.is_unlocked}
                      bg={"#DDE6FF"}
                      padding={"8px 12px"}
                      limit={4}
                      borderRadius={"4px"}
                      masterData={masterMonetizationPlatform}
                      masterItemName={"monetizationPlatformName"}
                      masterIconName="monetizationPlatformIcon"
                    />
                  </div>
                )}
                {influencer?.ContentCategory?.[0]?.length > 0 && (
                  <div className="w-[48.5%] flex">
                    <Contentcard
                      icon={<PiSquaresFourLight color="#424242" size={18} />}
                      heading={"Content category"}
                      number={influencer?.ContentCategory?.[0]?.length}
                      type={influencer?.ContentCategory?.[0]}
                      borderRadius={"4px"}
                      bg={"#FFFEEC"}
                      padding={"8px 12px"}
                      limit={3}
                      masterData={masterContentCategory}
                      masterItemName={"categoryName"}
                      masterIconName="categoryIcon"
                    />
                  </div>
                )}
                {influencer?.AudienceCategory?.[0]?.length > 0 && (
                  <div className="w-[48.5%] flex">
                    <Contentcard
                      icon={<PiSquaresFourLight color="#424242" size={18} />}
                      heading={"Audience category"}
                      number={influencer?.AudienceCategory?.[0]?.length}
                      type={influencer?.AudienceCategory?.[0]}
                      borderRadius={"4px"}
                      bg={"#FFEAF1"}
                      padding={"8px 12px"}
                      limit={3}
                      masterData={masterAudienceTypes}
                      masterItemName={"LkdAudienceTypeName"}
                      // masterIconName="audienceTypeIcon"
                    />
                  </div>
                )}
                {influencer?.AudienceData?.[0]?.data
                  ?.filter((item) => {
                    return masterAudiencePlatfroms?.find(
                      (platform) => platform?._id === item?.platform
                    )?.audiencePlatformName;
                  })
                  ?.reduce(
                    (total, platform) =>
                      parseInt(total) + parseInt(platform.audience || 0),
                    0
                  ) > 0 && (
                  <div className="w-full flex flex-col gap-[20px]">
                    <div className="flex items-center gap-[8px] text-[#616161] text-[14px] font-[600] ">
                      <IoIosPeople color="#424242" size={18} /> Audience
                      Presence :{" "}
                      {influencer?.AudienceData?.[0]?.data
                        ?.filter((item) => {
                          return masterAudiencePlatfroms?.find(
                            (platform) => platform?._id === item?.platform
                          )?.audiencePlatformName;
                        })
                        ?.reduce(
                          (total, platform) =>
                            parseInt(total) + parseInt(platform.audience || 0),
                          0
                        )}
                    </div>
                    <div className="flex gap-[20px]">
                      {influencer?.AudienceData?.[0]?.data
                        ?.filter((item) => {
                          return masterAudiencePlatfroms?.find(
                            (platform) => platform?._id === item?.platform
                          )?.audiencePlatformName;
                        })
                        ?.slice(0, 2)
                        ?.map((item) => {
                          const colorobj = {
                            "LinkedIn Profile": "bg-[#E8EDFB]",
                            "LinkedIn Page": "bg-[#E8EDFB]",
                            "Instagram Page": "bg-[#FFEAF1]",
                            "Telegram group": "bg-[#DEF5FF]",
                            "WhatsApp group": "bg-[#EDFFE6]",
                            "YouTube Channel": "bg-[#EDFFE6]",
                            "Facebook Group": "bg-[#E8EDFB]",
                            "Own Community": "bg-[#EFEFEF]",
                            "Own Website": "bg-[#EFEFEF]",
                            "Own Community App": "bg-[#EFEFEF]",
                            "Own APP": "bg-[#EFEFEF]",
                          };
                          return (
                            <CreatorSocialCard2
                              bg={
                                colorobj?.[
                                  masterAudiencePlatfroms?.find(
                                    (platform) =>
                                      platform?._id === item?.platform
                                  )?.audiencePlatformName
                                ]
                              }
                              logo={
                                masterAudiencePlatfroms?.find(
                                  (platform) => platform?._id === item?.platform
                                )?.audiencePlatformIcon
                              }
                              users={item?.audience}
                              Socialtype={
                                masterAudiencePlatfroms
                                  ?.find(
                                    (platform) =>
                                      platform?._id === item?.platform
                                  )
                                  ?.audiencePlatformName?.split(" ")[1]
                              }
                            />
                          );
                        })}
                      {influencer?.AudienceData?.[0]?.data?.length > 2 && (
                        <div
                          style={{
                            boxShadow:
                              "4px 4px 8px 0px rgba(136, 136, 136, 0.10)",
                          }}
                          className={`w-[266px] md:w-[266px] gap-[20px] py-[12px] px-[20px] flex flex-col items-center justify-center rounded-[8px] bg-[#EFEFEF]`}
                        >
                          <div className="flex text-[12px] font-[400] text-[#424242] gap-[8px] items-center justify-center ">
                            + {influencer?.AudienceData?.[0]?.data?.length - 2}{" "}
                            More
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
